import { useMe } from "components/use-hooks";
import { canManageUserGroups } from "../helpers/usergroup-access-helper";


const useCanManageUserGroups = () => {

    const currentUser = useMe();

    return canManageUserGroups(currentUser?.me);
};

export default useCanManageUserGroups;

